import { render, staticRenderFns } from "./GraduationSummarySection.vue?vue&type=template&id=53af010e&scoped=true"
import script from "./GraduationSummarySection.vue?vue&type=script&lang=js"
export * from "./GraduationSummarySection.vue?vue&type=script&lang=js"
import style0 from "./GraduationSummarySection.vue?vue&type=style&index=0&id=53af010e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af010e",
  null
  
)

export default component.exports